if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.variantData = null;
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      // Liest die aktuell gewählten Options-Werte (als Strings, in Options-Reihenfolge)
      // aus den gerenderten <select>- bzw. <fieldset>-Elementen.
      getSelectedOptionStrings() {
        const nodes = Array.from(this.querySelectorAll('select, fieldset'));

        return nodes.map((node) => {
          if (node.tagName === 'SELECT') {
            return node.value;
          }
          const checked = node.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      // Holt/cached die vollständige Variantenliste aus dem eingebetteten JSON.
      getVariantData() {
        if (!this.variantData) {
          const jsonScript = this.querySelector('[data-product-variants]');
          this.variantData = jsonScript ? JSON.parse(jsonScript.textContent) : [];
        }
        return this.variantData;
      }

      // Findet die Variante, die zu den aktuell gewählten Options-Werten passt.
      // Fallback: wenn keine exakte Kombination existiert, wird - analog zur
      // Liquid-Logik von "true_variant" - die erste verfügbare Variante genommen,
      // die zumindest zur ersten Option passt.
      findMatchingVariant(optionValues) {
        const variants = this.getVariantData();

        if (!variants.length) return null;

        let match = variants.find((variant) =>
          variant.options.every((opt, index) => opt === optionValues[index])
        );

        if (!match) {
          const candidates = variants.filter(
            (variant) => variant.options[0] === optionValues[0]
          );
          match = candidates.find((variant) => variant.available) || candidates[0];
        }

        return match || variants[0];
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          if (window.FoxTheme && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish(
              FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
              {
                data: {
                  event,
                  target,
                  selectedOptionValues: this.selectedOptionValues,
                },
              }
            );
          }

          this.reloadWithCorrectVariant();
        });
      }

      reloadWithCorrectVariant() {
        const optionValues = this.getSelectedOptionStrings();
        const variant = this.findMatchingVariant(optionValues);

        if (!variant) return;

        // Hidden Cart-Form Input direkt aktualisieren, damit ein evtl.
        // sofortiges Add-to-Cart (vor dem Reload) bereits die richtige
        // Variante nutzt.
        const variantInput =
          document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
          document.querySelector('input[name="id"]');

        if (variantInput) {
          variantInput.value = variant.id;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);

        window.location.href = url.toString();
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const oldSelected = Array.from(target.options).find((option) =>
            option.hasAttribute('selected')
          );

          if (oldSelected) {
            oldSelected.removeAttribute('selected');
          }

          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;

          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value] > .swatch');

          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              'unset'
            );
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value]');

          if (selectedSwatchValue) {
            selectedSwatchValue.innerHTML = value;
          }
        }
      }
    }
  );
}

/* Studioline Bildwechsel */
(function () {
  let lastUrl = null;

  function getSelectedValue() {
    return document
      .querySelector('.tcustomizer__dropdown-button span')
      ?.textContent
      ?.trim();
  }

  function getSku() {
    return document
      .querySelector('.product__sku')
      ?.textContent
      ?.replace('Artikelnummer:', '')
      ?.trim();
  }

  function getImage() {
    return (
      document.querySelector('img[id^="SelectedVariantImage"]') ||
      document.querySelector('.product__media-list img')
    );
  }

  function updateStudiolineImage() {
    const selectedValue = getSelectedValue();
    const sku = getSku();
    const image = getImage();

    if (!image || !sku || selectedValue !== 'STUDIOLINE® by MTL') return;

    const newUrl = `https://mtlpravatelabel.com/cdn/shop/files/Studioline_${sku}.png`;

    if (image.src.includes(`Studioline_${sku}.png`)) return;

    lastUrl = newUrl;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', newUrl);
    image.style.objectFit = 'contain';
  }

  function forceUpdateLoop() {
    updateStudiolineImage();

    let count = 0;
    const interval = setInterval(() => {
      count++;
      updateStudiolineImage();

      if (count >= 20) {
        clearInterval(interval);
      }
    }, 100);
  }

  function initObserver() {
    const productMedia =
      document.querySelector('.product__media-list') ||
      document.querySelector('.product__media-gallery') ||
      document.body;

    const observer = new MutationObserver(() => {
      updateStudiolineImage();
    });

    observer.observe(productMedia, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes']
    });

    forceUpdateLoop();
  }

  document.addEventListener('DOMContentLoaded', initObserver);
  document.addEventListener('click', forceUpdateLoop);
  document.addEventListener('change', forceUpdateLoop);
})();